module.exports = __webpack_public_path__ + "img/close-white.a2317182.svg";